import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import StopIcon from '@mui/icons-material/Stop';
import { alpha, useTheme } from '@mui/material/styles';

type DeliveryStateButtonProps = {
  deliveryState: 'play' | 'pause' | 'loading' | 'stop';
  onClick: () => void;
};

const DeliveryStateButton: React.FC<DeliveryStateButtonProps> = ({ deliveryState, onClick }) => {
  const theme = useTheme();

  const { icon, tooltip, color } = (() => {
    switch (deliveryState) {
      case 'play':
        return { icon: <PlayArrowIcon />, tooltip: 'Auto-reply On', color: theme.palette.success.main };
      case 'pause':
        return { icon: <PauseIcon />, tooltip: 'Auto-reply Paused', color: theme.palette.warning.main };
      case 'loading':
        return { icon: <CircularProgress size={20} />, tooltip: 'Updating…', color: theme.palette.grey[500] };
      case 'stop':
      default:
        return { icon: <StopIcon />, tooltip: 'AI Stopped', color: theme.palette.error.main };
    }
  })();

  const handleClick = () => {
    if (deliveryState === 'loading') return;
    onClick();
  };

  return (
    <Tooltip arrow title={tooltip}>
      <span>
        <IconButton
          onClick={handleClick}
          disabled={deliveryState === 'loading' || deliveryState === 'stop'}
          sx={{
            height: 36,
            width: 36,
            bgcolor: alpha(color, 0.15),
            color,
            '&:hover': {
              bgcolor: alpha(color, 0.25)
            }
          }}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default DeliveryStateButton;
